import { render, staticRenderFns } from "./personView.vue?vue&type=template&id=433ccefb&scoped=true&"
import script from "./personView.vue?vue&type=script&lang=js&"
export * from "./personView.vue?vue&type=script&lang=js&"
import style0 from "./personView.vue?vue&type=style&index=0&id=433ccefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ccefb",
  null
  
)

export default component.exports